import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";
import TextFieldNonFieldEditor from "components/fields/TextFieldNonFieldEditor";
import { useState } from "react";
import styled from "styled-components";
import { FieldError } from "types";

export type Props = {
  lessonName: string;
  onSubmitClick(numberofMonths: number): void;
  onCancelClick(): void;
};

export default function AdvanceMonthsDialog({
  lessonName,
  onSubmitClick,
  onCancelClick,
}: Props) {
  const [selectedNumberOfMonths, setSelectedNumberOfMonths] = useState<string>(
    ""
  );
  const [error, setError] = useState<FieldError>();

  return (
    <Dialog maxWidth="xs" fullWidth open id={"advanceMonths"}>
      <DialogTitle>
        <Typography>Advance Months - {lessonName}</Typography>
      </DialogTitle>
      <DialogContent>
        <TextFieldNonFieldEditor
          id="advanceMonths"
          label="Number of Months"
          value={selectedNumberOfMonths}
          onChange={(value) => {
            if (value !== "") {
              const numericValue = +value;

              if (isNaN(numericValue)) {
                setError({
                  id: "advanceMonthsError",
                  label: "Advance Months",
                  error: "Must be a valid number.",
                });
              } else if (numericValue <= 0) {
                setError({
                  id: "advanceMonthsError",
                  label: "Advance Months",
                  error: "Must be greater than zero.",
                });
              } else if (error) {
                setError(undefined);
              }
            }
            setSelectedNumberOfMonths(value.trim());
          }}
          required
          errObj={error}
          multiline={false}
          disabled={false}
        />

        {selectedNumberOfMonths && !error && (
          <Message>
            Submitting this will advance every transaction date in this lesson
            by {selectedNumberOfMonths}{" "}
            {selectedNumberOfMonths === "1" ? "month" : "months"}.
          </Message>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancelClick}>Cancel</Button>
        <Button
          variant="contained"
          disabled={selectedNumberOfMonths === "" || !!error}
          onClick={() => {
            if (selectedNumberOfMonths === "") {
              setError({
                id: "advanceMonthsError",
                label: "Advance Months",
                error: "Is Required.",
              });
              return;
            }

            onSubmitClick((selectedNumberOfMonths as unknown) as number);
          }}
        >
          Submit
        </Button>
      </DialogActions>
    </Dialog>
  );
}

const Message = styled.div`
  margin: -10px 5px 0 5px;
  font-size: 14px;
  color: #666;
`;
